



























































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PilihanChip from "./PilihanChip.vue";
import { InstruksiRah, KatalogRah } from "@/types/rekam_asuhan_hemodialisis";
import { ATURAN, AturanIsian } from "./aturanIsian";

@Component({
  components: { PilihanChip }
})
export default class InstruksiMedikSection extends Vue {
  @Prop({ type: Object, required: true }) readonly instruksi!: InstruksiRah;
  @Prop({ type: Object, required: true }) readonly katalog!: KatalogRah;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  ATURAN = ATURAN;

  aturan(fn: AturanIsian): AturanIsian[] {
    return this.disabled ? [] : [fn];
  }

  ubahJenisHd(nilai: string | null) {
    this.instruksi.jenis_hd = nilai;
    if (nilai !== "lain") this.instruksi.jenis_hd_lain = null;
  }

  ubahMaintenance(nilai: string | null) {
    this.instruksi.heparin_maintenance = nilai;
    if (!nilai) this.instruksi.heparin_maintenance_dosis = null;
  }

  ubahTanpaHeparin(nilai: boolean | null) {
    this.instruksi.tanpa_heparin = !!nilai;
    if (!nilai) {
      this.instruksi.tanpa_heparin_penyebab = null;
      this.instruksi.program_bilas = false;
    }
  }
}
